import { useLeagueSport } from '../../hooks/use-league-sport';
import {
    EVENT_LIST_PAGE_SIZE,
    useLeagueTraditionalMatchupDataWithMarkets,
} from '../../hooks/use-league-traditional-matchup-data';
import { EventList } from '../EventList';
import { LeagueSectionTitle } from './LeagueSectionTitle';

export const LiveEventsSection = ({ leagueId }: { leagueId: string }) => {
    const sport = useLeagueSport(leagueId);
    const matchupData = useLeagueTraditionalMatchupDataWithMarkets({
        leagueId,
        limit: EVENT_LIST_PAGE_SIZE,
        isLive: true,
    });

    return (
        <EventList
            leagueId={leagueId}
            matchupData={matchupData}
            header={<LeagueSectionTitle sport={sport} section="lines" />}
            isLive
        />
    );
};
